var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFavourite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.6222 20.9156C12.2889 21.0281 11.7333 21.0281 11.3778 20.9156C8.48889 19.9028 2 15.739 2 8.64927C2 5.52079 4.48889 3 7.55556 3C9.37778 3 10.9778 3.87777 12 5.2507C13.0222 3.87777 14.6222 3 16.4444 3C19.5111 3 22 5.52079 22 8.64927C21.9778 15.739 15.5111 19.9028 12.6222 20.9156Z",
    stroke: "#979592",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFavourite);
export default __webpack_public_path__ + "static/media/favourite.175f063c04fc47e32456f4e2bf7162e0.svg";
export { ForwardRef as ReactComponent };